export const Banner = () => {
  return (
    <div className="banner">
      <div className="banner-container">
            <div className="banner__content">
        <div className="txt">
          <div className="txt__content" id="banner-text">
            <p class="pre-title">DÍAS MÁS CORTOS,</p>
            <h1>SE NOS VA EL SOL...</h1>
            <p>NUESTROS ESTILAZOS PARA CUANDO CAIGA LA HELÁ</p>
            {/* <h1 className="animated-title blink">¡ÚLTIMOS DÍAS!</h1> */}
          </div>
        </div>
        <div className="buttons">
          <div className="btn-white center">
            <a href="https://www.hakahonu.cl/oto-o.html" target='_parent' id='C0.1'>VER MÁS</a>
          </div>
          {/* <div className="btn-white right">
            <a href="https://www.hakahonu.cl/summer-sale/hombre.html" target='_parent' id='C0.2'>HOMBRE</a>
          </div> */}
        </div>
      </div> 
      </div>
    </div>
  );
};
